var React = require('react');

function SymbolFairInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"99.2782","cy":"99.2784","r":"50","transform":"rotate(-38.6598 99.2782 99.2784)","fill":"#FF8A00","key":0}),React.createElement("path",{"d":"M99.2773 49.2783C86.0165 49.2783 73.2988 54.5462 63.922 63.923C54.5452 73.2998 49.2773 86.0175 49.2773 99.2783C49.2773 112.539 54.5452 125.257 63.922 134.634C73.2988 144.01 86.0165 149.278 99.2773 149.278L99.2773 99.2783L99.2773 49.2783Z","fill":"#FED285","key":1})]);
}

SymbolFairInline.defaultProps = {"width":"199","height":"199","viewBox":"0 0 199 199","fill":"none"};

module.exports = SymbolFairInline;

SymbolFairInline.default = SymbolFairInline;
